<template>
    <div>
        <div class="col-12 mb-4 d-sm-flex justify-content-sm-between align-items-sm-baseline">
            <h4>Currency rates</h4>
            <div class="d-sm-flex col-12 col-sm-auto text-right pr-0 mt-2 mt-sm-0">
                <div class="input-group">
                    <DatePicker readonly
                                class="form-control"
                                autocomplete="off"
                                :value="ratesRequestDate"
                                @input="setRequestDate($event)"
                                :config="{
                                  plugins: monthSelect,
                                }"/>
                    <div class="input-group-append">
                        <button @click="parseCurrencies"
                                :disabled="loading"
                                class="btn btn-outline-secondary">
                            Get rates
                        </button>
                    </div>
                </div>
                <b-dropdown variant="link"
                            no-caret
                            right>
                    <template v-slot:button-content>
                        <i class="material-icons">more_vert</i>
                    </template>
                    <b-dropdown-item @click="newCurrencyRate"
                                     :disabled="loading">
                        New rate
                    </b-dropdown-item>
                </b-dropdown>
            </div>
        </div>
        <AppTable :columns="columns"
                  :rows="currencyRates"
                  :query="query"
                  @on-row-click="viewCurrencyRate"
                  :loading="loading"
                  :total="total"
                  @on-query-change="onQueryChange"/>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import DatePicker from 'vue-flatpickr-component';
import MonthSelectPlugin from 'flatpickr/dist/plugins/monthSelect/index';
import { BDropdown, BDropdownItem } from 'bootstrap-vue';
import NotificationService from '../../services/notification.service';
import { formatDate } from '../../filters/date.filter';
import 'flatpickr/dist/flatpickr.min.css';
import 'flatpickr/dist/plugins/monthSelect/style.css';
import AppTable from '../form/AppTable';

export default {
  components: {
    AppTable,
    DatePicker,
    BDropdown,
    BDropdownItem,
  },
  filters: {
    date: formatDate,
  },
  computed: {
    ...mapGetters({
      currencyRates: 'currencyRates/currencyRates',
    }),
    ...mapState({
      query: (state) => state.currencyRates.query,
      total: (state) => state.currencyRates.totalCurrencyRates,
      ratesRequestDate: (state) => state.currencyRates.ratesRequestDate,
    }),
    columns() {
      return [
        {
          label: 'From',
          field: 'from_code',
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'To',
          field: 'to_code',
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Rate',
          field: 'rate',
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Recorded at',
          field: 'recorded_at',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd HH:mm:ss',
          dateOutputFormat: 'dd MMM yyyy',
          filterOptions: {
            enabled: true,
          },
        },
      ];
    },
  },
  data() {
    return {
      loading: false,
      monthSelect: [new MonthSelectPlugin({
        shorthand: true,
        // dateFormat: 'MMMM YYYY',
      })],
    };
  },
  mounted() {
    this.getCurrencyRates();
  },
  methods: {
    parseCurrencies() {
      this.$store.dispatch('currencyRates/parseCurrencies')
        .then((res) => {
          NotificationService.success(res.message);
          this.getCurrencyRates();
        })
        .catch((err) => {
          NotificationService.success(err.response.data.errors);
        });
    },
    newCurrencyRate() {
      this.$router.push({
        name: 'currency-rate',
        params: { id: 'new' },
      });
    },
    getCurrencyRates() {
      this.loading = true;

      this.$store.dispatch('currencyRates/getCurrencyRates')
        .finally(() => {
          this.loading = false;
        });
    },
    viewCurrencyRate(event) {
      this.$router.push({
        name: 'currency-rate',
        params: { id: event.row.id },
      });
    },
    setRequestDate(date) {
      this.$store.commit('currencyRates/ratesRequestDate', date);
    },
    onQueryChange(props) {
      this.$store.commit('currencyRates/queryProps', props);
      this.getCurrencyRates();
    },
  },
};
</script>
